import React from "react";
import {withSnackbar, WithSnackbarProps} from "notistack";
import {Redirect, RouteComponentProps} from "react-router-dom";
import {Box} from "@mui/material";
import ZPlayLoader from "commons/zplay-loader";
import NavigationBack from "commons/navigation/navigation-back/navigation-back";
import {EditSubscriptionState} from "./models";
import {ContentProducerService} from "services/content-producer-service";
import {Subscription} from "models";
import {ErrorResponseApi} from "models/response";
import {t} from "@lingui/macro";
import { CreateAndEditSubscription } from "components/backoffice/subscription";

class EditSubscription extends React.Component<WithSnackbarProps & RouteComponentProps<any>, EditSubscriptionState> {

    constructor(props: any) {
        super(props);

        this.state={
            isLoading: true,
            subscription: null,
            subscriptionError: false
        }
    }

    componentDidMount() {
        ContentProducerService.getSubscription(this.props.match.params.id, this.getSubscriptionSuccessCallback, this.getSubscriptionErrorCallback)
    }

    getSubscriptionSuccessCallback = (data: Subscription) => {
        this.setState(() => ({
            subscription: data,
            isLoading: false
        }))
    }

    getSubscriptionErrorCallback = (err: ErrorResponseApi) => {
        this.setState(() => ({
            subscriptionError: true,
            isLoading: false
        }))
    }

    private checkRequest = (request : Subscription):boolean =>{
        let errorsArray: string[] = [];

        if(request.name === "" || !request.name)
            errorsArray.push(t({
                id: "es-no-name-create-subscription",
                message: "È necessario inserire il nome"
            }));

        if(request.monthlyPriceWithoutVAT === -1)
            errorsArray.push(t({
                id: "es-no-monthly-price-create-subscription",
                message: "È necessario inserire il prezzo mensile"
            }));

        if(request.yearlyPriceWithoutVAT === -1)
            errorsArray.push(t({
                id: "es-no-yearly-price-create-subscription",
                message: "È necessario inserire il prezzo annuale"
            }));


        if (errorsArray.length > 0)
            this.props.enqueueSnackbar(errorsArray.join(", "),
                { variant: "error" });

        return errorsArray.length === 0;

    }

    private submitForm = (request: Subscription) => {
        if(!this.checkRequest(request))
            return

        this.setState(() => ({
            isLoading: true
        }))
        ContentProducerService.editSubscription(request.id, request, this.editSubscriptionSuccessCallback, this.editSubscriptionErrorCallback);
    };


    editSubscriptionSuccessCallback = (data: any) => {
        this.setState(() => ({
            isLoading: false
        }))

        this.props.enqueueSnackbar(t({
            id: "es-success-edit-subscription",
            message: "L'abbonamento è stato aggiornato"
        }), {
            variant: "success",
        })
    }

    editSubscriptionErrorCallback = (err: ErrorResponseApi) => {
        this.setState(() => ({
            isLoading: false,
        }));

        this.props.enqueueSnackbar(t({
            id: "es-error-edit-subscription",
            message: "Si è verificato un errore. Non è stato possibile aggiornare l'abbonamento"
        }), {
            variant: "error",
        });
    }

    render() {
        return (
            <Box sx={{ p: 5 }}>
                {this.state.isLoading && <ZPlayLoader />}
                <NavigationBack/>
                {this.state.subscriptionError && <Redirect to={"/not-found"} />}
                {!this.state.subscriptionError && 
                    <Box maxWidth={"1000px"} padding={"30px 10px 10px"} margin={"0 auto"}>
                        {!this.state.isLoading &&
                            <CreateAndEditSubscription
                                subscription={this.state.subscription}
                                onSubmit={this.submitForm}
                            />
                        }
                    </Box>}
            </Box>
        );
    }
}

export default withSnackbar(EditSubscription);